
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/design-system",
      function () {
        return require("private-next-pages/download/design-system/index.tsx");
      }
    ]);
  